module.exports = __webpack_public_path__ + "static/media/aspenLogo.e9d19dc9.png";